<template>
  <div>
    <b-modal
      :id="id"
      :ref="id"
      v-model="internalShow"
      :cancel-title-html="cancelButtonText"
      :ok-title-html="confirmButtonText"
      :title="title"
      :v-bind="$attrs"
      no-close-on-backdrop
      no-close-on-esc
      centered
      cancel-variant="outline-primary border-2"
      body-class="pt-0"
      button-size="md"
      content-class="rounded-xl p-2 p-sm-3 shadow-lg text-dark"
      footer-class="mt-4 mt-sm-0 border-top-0 d-flex flex-column-reverse flex-md-row items-flex-grow align-items-stretch"
      header-class="border-bottom-0 pb-0 h1"
      ok-variant="danger"
      title-class="h2 font-weight-bold text-dark"
      @close="$emit('cancel')"
      @cancel="$emit('cancel')"
      @ok="$emit('confirm')"
    >
      <p class="my-1">{{ message }}</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'DpConfirmationModal',
  props: {
    id: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      internalShow: this.show,
    };
  },
};
</script>

<style lang="scss">
.rounded-xl {
  border-radius: 1.25rem !important;
}

.d-flex.items-flex-grow > * {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
</style>